<template>
  <div id="booking-widget">
    <div v-if="propertyerror">
      <div class="container">
        <div class="alert alert-danger">
          <strong>Invalid property id {{ propertyid }}.</strong> Please contact
          <a href="mailto:info@reserveport.com">info@reserveport.com.</a>
        </div>
      </div>
    </div>
    <div class="reserveport-form-wrap" v-if="!propertyerror">
      <div class="container vue-content-body">
        <div class="hbf">
          <div class="inner">
            <!-- search bar improved -->
            <h3>
              Check Availability
              <span v-if="loadResult"><small style="font-weight: 200" v-show="spinner">({{ bookingData.name
                  }})</small></span>
            </h3>

            <div class="vue-search-box" v-show="spinner" v-if="multipropertyStatus == false && clientemail == false">
              <form>
                <div class="row vue-date-box">
                  <div class="col-md-3">
                    <label class="guest-link">Arrival Date</label>
                    <div class="form-group vue-sd-container">
                      <CheckinDate @checkin-date-changed="checkAvailabilty('l')"></CheckinDate>
                    </div>
                  </div>

                  <div class="col-md-3 vue-md_p5">
                    <label class="guest-link">Departure Date</label>
                    <div class="form-group vue-sd-container">
                      <CheckoutDate @checkout-date-changed="checkAvailabilty('l')"></CheckoutDate>
                    </div>
                  </div>
                  <div class="col-md-3 vue-md_p5">
                    <label class="guest-link">Occupancy</label>
                    <div class="form-group">
                      <div id="vue-guests-groups" class="form-control vue-small_large_select" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false" @click="stickMenu">
                        <div id="occupancy-control" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                          <div id="occupancy-text-2" class="pull-left">
                            <span v-if="room > 1">{{ room }} {{ roomLabel.plural }}
                            </span>
                            <span v-else>{{ room }} {{ roomLabel.singular }} |
                              {{ guest }} Guest</span>
                          </div>
                          <div class="pull-right">
                            <img src="https://reservations.reserveport.com/static/img/icon.png" alt="" loading="lazy"
                              width="15px" />
                          </div>
                        </div>
                        <div id="vue-dropdown-home" class="dropdown-menu vue-paddt15">
                          <div class="vue-mobile pull-left">
                            <div class="row">
                              <div class="col-md-6 col-6">
                                <label>{{ roomLabel.plural }}</label>
                              </div>
                              <div class="col-md-6 col-6">
                                <div class="paddb10 booking-btngrp block">
                                  <button type="button" v-on:click.prevent="removeRoom" class="vue-btnb"
                                    id="minus-vue-btn-roomsfx">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                  <input disabled="disabled" class="vue-fxcount" :value="room" id="roomsfx"
                                    name="roomsfx" type="text" />
                                  <button type="button" v-on:click.prevent="addRoom" class="vue-btnb"
                                    id="plus-vue-btn-roomsfx">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div id="vue-occupancy-details" v-if="room == 1">
                              <div class="row">
                                <div class="col-md-6 col-sm-7 col-6">
                                  <label>Adults</label><small class="vue-ageDiv">({{
                                    ageGroupsDetails.adult_age
                                    }}yr+)</small>
                                </div>
                                <div class="col-md-6 col-sm-5 col-6">
                                  <div class="paddb10 booking-btngrp block">
                                    <button type="button" v-on:click.prevent="removeAdult" class="vue-btnb"
                                      id="minus-vue-btn-adultsfx">
                                      <i class="fa fa-minus"></i>
                                    </button>
                                    <input disabled="disabled" class="vue-fxcount" v-model="defaultAdultNo"
                                      id="occ_adult_l" name="adultsfx" type="text" />
                                    <button type="button" v-on:click.prevent="addAdult" class="vue-btnb"
                                      id="plus-vue-btn-adultsfx">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div class="clearfix clear"></div>
                              <div class="row" style="padding-top: 10px; padding-bottom: 10px"
                                v-if="ageGroupsDetails.children_allowed != 0">
                                <div class="col-md-6 col-sm-6 col-6">
                                  <label>Children</label><small class="vue-ageDiv">({{ ageGroupsDetails.child_min_age }}
                                    -
                                    {{
                                    ageGroupsDetails.child_max_age
                                    }}yr)</small>
                                </div>
                                <div class="col-md-6 col-sm-6 col-6">
                                  <div class="paddb10 booking-btngrp block">
                                    <button type="button" v-on:click.prevent="removeChildren" class="vue-btnb"
                                      id="minus-vue-btn-childrenfx">
                                      <i class="fa fa-minus"></i>
                                    </button>
                                    <input disabled="disabled" class="vue-fxcount" v-model="defaultChildrenNo"
                                      id="occ_children_l" name="childrenfx" type="text" />
                                    <button type="button" v-on:click.prevent="addChildren" class="vue-btnb"
                                      id="plus-vue-btn-childrenfx">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                                <div class="col-md-12" v-if="children > 0">
                                  <div id="vue-ageDiv">
                                    <label id="age_label">Please select the child's age. Children
                                      are considered to be between
                                      {{ ageGroupsDetails.child_min_age }} and
                                      {{
                                      ageGroupsDetails.child_max_age
                                      }}
                                      years.</label>
                                    <div class="child_div" v-for="child in children" :key="child">
                                      <label>Child {{ child }}</label>
                                      <select id="child_1_age" name="child_1_age" class="child_ages rounded5"
                                        v-on:change="
                                          updateChildAges($event, child)
                                        ">
                                        <option value="">Age</option>
                                        <option v-for="(
                                            childrenagerange, ageindex
                                          ) in computeChildrenAgeRange(
                                            ageGroupsDetails
                                          )" :key="ageindex" :value="childrenagerange.age">
                                          {{ childrenagerange.age }} yrs
                                        </option>
                                      </select>
                                    </div>
                                    <div v-if="ageError" style="color:red">
                                      <small>Please Fill the Child {{child}} Age before adding another child</small>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="clearfix clear"></div>
                              <div class="row" v-if="ageGroupsDetails.babies_allowed != 0">
                                <div class="col-md-6 col-sm-6 col-6">
                                  <label>Infants</label><small class="vue-ageDiv">(0-{{
                                    ageGroupsDetails.baby_max_age
                                    }}yr)</small>
                                </div>
                                <div class="col-md-6 col-sm-6 col-6">
                                  <div class="paddb10 booking-btngrp block">
                                    <button type="button" v-on:click.prevent="removeBabies" class="vue-btnb"
                                      id="minus-vue-btn-babiesfx">
                                      <i class="fa fa-minus"></i>
                                    </button>
                                    <input disabled="disabled" class="vue-fxcount" v-model="defaultbabiesNo"
                                      id="occ_babies_l" name="babiesfx" type="text" />
                                    <button type="button" v-on:click.prevent="addBabies" class="vue-btnb"
                                      id="plus-vue-btn-babiesfx">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div v-else class="row-fluid">
                              <div class="col-md-12 col-md-12 col-12">
                                <div id="vue-occupancy-details-text" class="hide">
                                  <div class="alert alert-warning mrgb5 paddtb5" role="alert">
                                    Guest occupancy selection in each
                                    {{ roomLabel.singular }} will be availed on
                                    the search results page.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="clearfix clear"></div>
                          <div class="col-md-12">
                            <a href="javascript:void(0);" class="pull-right" @click="close"><i class="fa fa-close"></i>
                              Close</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end here -->
                  <div class="col-md-3 col-sm-4 vue-btn-wrap avail-wrap vue-md_p5">
                    <span id="vue-havepromo" class="vue-horizontal" @click="showPromoCode">Have a promotion code?
                    </span>
                    <div id="actPromoCodeact" v-if="showpromo || promo != ''">
                      <input type="text" id="coupon_code_largeScreen" v-model="promo"
                        class="vue-coupon_code_screen vue-horizontal" placeholder="Promo Code" />
                    </div>
                    <!-- <transition name="slide-fade"> -->
                    <!-- </transition> -->
                    <button id="vue-btn-search" v-on:click.prevent="checkAvailabilty('l')"
                      class="btn btn-md btn-orange-solid">
                      <div v-show="isSearching">
                        <span v-html="searchspinner"></span>
                      </div>
                      <div v-show="!isSearching">Check Availability</div>
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div class="vue-search-box" v-show="spinner" v-else>
              <form>
                <div class="row vue-date-box">
                  <div class="col-md-3" v-if="multipropertyStatus == true">
                    <label>Destination</label>
                    <div class="form-group" id="vue-guests-groups">
                      <select class="form-control vue-email_screen sd vue-destination"
                        @click="updateRoomFilter(multiproperties)" v-model="destination">
                        <option :value="initialPropertyId">{{ initialPropertyName }}</option>
                        <option :value="pdestination.id" v-for="(pdestination, destindex) in multiproperties.filter(p => p.id !== initialPropertyId)"
                          :key="destindex">
                          {{ pdestination.propertyName }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <label>Arrival Date</label>
                    <div class="form-group vue-sd-container">
                      <CheckinDate @checkin-date-changed="checkAvailabilty('l')"></CheckinDate>
                    </div>
                  </div>

                  <div class="col-md-2 vue-md_p5">
                    <label>Departure Date</label>
                    <div class="form-group vue-sd-container">
                      <CheckoutDate @checkout-date-changed="checkAvailabilty('l')"></CheckoutDate>
                    </div>
                  </div>
                  <div class="col-md-2 vue-md_p5" v-if="multipropertyStatus == true && clientemail == true">
                    <label class="guest-link">Occupancy</label>
                    <div class="form-group">
                      <div id="vue-guests-groups" class="form-control vue-small_large_select" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false" @click="stickMenu">
                        <div id="occupancy-control" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                          <div id="occupancy-text-2" class="pull-left">
                            <span v-if="room > 1">{{ room }} {{ roomLabel.plural }}
                            </span>
                            <span v-else>{{ room }} {{ roomLabel.singular }} |
                              {{ guest }} Guest</span>
                          </div>
                          <div class="pull-right">
                            <img src="https://reservations.reserveport.com/static/img/icon.png" alt="" width="15px" />
                          </div>
                        </div>
                        <div id="vue-dropdown-home" class="dropdown-menu vue-paddt15">
                          <div class="vue-mobile pull-left">
                            <div class="row">
                              <div class="col-md-6 col-6">
                                <label>{{ roomLabel.plural }}</label>
                              </div>
                              <div class="col-md-6 col-6">
                                <div class="paddb10 booking-btngrp block">
                                  <button type="button" v-on:click.prevent="removeRoom" class="vue-btnb"
                                    id="minus-vue-btn-roomsfx">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                  <input disabled="disabled" class="vue-fxcount" :value="room" id="roomsfx"
                                    name="roomsfx" type="text" />
                                  <button type="button" v-on:click.prevent="addRoom" class="vue-btnb"
                                    id="plus-vue-btn-roomsfx">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div id="vue-occupancy-details" v-if="room == 1">
                              <div class="row">
                                <div class="col-md-6 col-sm-7 col-6">
                                  <label>Adults</label><small class="vue-ageDiv">({{
                                    ageGroupsDetails.adult_age
                                    }}yr+)</small>
                                </div>
                                <div class="col-md-6 col-sm-5 col-6">
                                  <div class="paddb10 booking-btngrp block">
                                    <button type="button" v-on:click.prevent="removeAdult" class="vue-btnb"
                                      id="minus-vue-btn-adultsfx">
                                      <i class="fa fa-minus"></i>
                                    </button>
                                    <input disabled="disabled" class="vue-fxcount" v-model="defaultAdultNo"
                                      id="occ_adult_l" name="adultsfx" type="text" />
                                    <button type="button" v-on:click.prevent="addAdult" class="vue-btnb"
                                      id="plus-vue-btn-adultsfx">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div class="clearfix clear"></div>
                              <div class="row" style="padding-top: 10px; padding-bottom: 10px"
                                v-if="ageGroupsDetails.children_allowed != 0">
                                <div class="col-md-6 col-sm-6 col-6">
                                  <label>Children</label><small class="vue-ageDiv">({{ ageGroupsDetails.child_min_age }}
                                    -
                                    {{
                                    ageGroupsDetails.child_max_age
                                    }}yr)</small>
                                </div>
                                <div class="col-md-6 col-sm-6 col-6">
                                  <div class="paddb10 booking-btngrp block">
                                    <button type="button" v-on:click.prevent="removeChildren" class="vue-btnb"
                                      id="minus-vue-btn-childrenfx">
                                      <i class="fa fa-minus"></i>
                                    </button>
                                    <input disabled="disabled" class="vue-fxcount" v-model="defaultChildrenNo"
                                      id="occ_children_l" name="childrenfx" type="text" />
                                    <button type="button" v-on:click.prevent="addChildren" class="vue-btnb"
                                      id="plus-vue-btn-childrenfx">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                                <div class="col-md-12" v-if="children > 0">
                                  <div id="vue-ageDiv">
                                    <label id="age_label">Please select the child's age. Children
                                      are considered to be between
                                      {{ ageGroupsDetails.child_min_age }} and
                                      {{
                                      ageGroupsDetails.child_max_age
                                      }}
                                      years.</label>
                                    <div class="child_div" v-for="child in children" :key="child">
                                      <label>Child {{ child }}</label>
                                      <select id="child_1_age" name="child_1_age" class="child_ages rounded5"
                                        v-on:change="
                                          updateChildAges($event, child)
                                        ">
                                        <option value="">Age</option>
                                        <option v-for="(
                                            childrenagerange, ageindex
                                          ) in computeChildrenAgeRange(
                                            ageGroupsDetails
                                          )" :key="ageindex" :value="childrenagerange.age">
                                          {{ childrenagerange.age }} yrs
                                        </option>
                                      </select>
                                    </div>
                                    <div v-if="ageError" style="color:red">
                                      <small>Please Fill the Child {{child}} Age before adding another child</small>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="clearfix clear"></div>
                              <div class="row" v-if="ageGroupsDetails.babies_allowed != 0">
                                <div class="col-md-6 col-sm-6 col-6">
                                  <label>Infants</label><small class="vue-ageDiv">(0-{{
                                    ageGroupsDetails.baby_max_age
                                    }}yr)</small>
                                </div>
                                <div class="col-md-6 col-sm-6 col-6">
                                  <div class="paddb10 booking-btngrp block">
                                    <button type="button" v-on:click.prevent="removeBabies" class="vue-btnb"
                                      id="minus-vue-btn-babiesfx">
                                      <i class="fa fa-minus"></i>
                                    </button>
                                    <input disabled="disabled" class="vue-fxcount" v-model="defaultbabiesNo"
                                      id="occ_babies_l" name="babiesfx" type="text" />
                                    <button type="button" v-on:click.prevent="addBabies" class="vue-btnb"
                                      id="plus-vue-btn-babiesfx">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div v-else class="row-fluid">
                              <div class="col-md-12 col-md-12 col-12">
                                <div id="vue-occupancy-details-text" class="hide">
                                  <div class="alert alert-warning mrgb5 paddtb5" role="alert">
                                    Guest occupancy selection in each
                                    {{ roomLabel.singular }} will be availed on
                                    the search results page.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="clearfix clear"></div>
                          <div class="col-md-12">
                            <a href="javascript:void(0);" class="pull-right" @click="close"><i class="fa fa-close"></i>
                              Close</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3 vue-md_p5" v-else>
                    <label class="guest-link">Occupancy</label>
                    <div class="form-group">
                      <div id="vue-guests-groups" class="form-control vue-small_large_select" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false" @click="stickMenu">
                        <div id="occupancy-control" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                          <div id="occupancy-text-2" class="pull-left">
                            <span v-if="room > 1">{{ room }} {{ roomLabel.plural }}
                            </span>
                            <span v-else>{{ room }} {{ roomLabel.singular }} |
                              {{ guest }} Guest</span>
                          </div>
                          <div class="pull-right">
                            <img src="https://reservations.reserveport.com/static/img/icon.png" alt="" loading="lazy"
                              width="15px" />
                          </div>
                        </div>
                        <div id="vue-dropdown-home" class="dropdown-menu vue-paddt15">
                          <div class="vue-mobile pull-left">
                            <div class="row">
                              <div class="col-md-6 col-6">
                                <label>{{ roomLabel.plural }}</label>
                              </div>
                              <div class="col-md-6 col-6">
                                <div class="paddb10 booking-btngrp block">
                                  <button type="button" v-on:click.prevent="removeRoom" class="vue-btnb"
                                    id="minus-vue-btn-roomsfx">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                  <input disabled="disabled" class="vue-fxcount" :value="room" id="roomsfx"
                                    name="roomsfx" type="text" />
                                  <button type="button" v-on:click.prevent="addRoom" class="vue-btnb"
                                    id="plus-vue-btn-roomsfx">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div id="vue-occupancy-details" v-if="room == 1">
                              <div class="row">
                                <div class="col-md-6 col-sm-7 col-6">
                                  <label>Adults</label><small class="vue-ageDiv">({{
                                    ageGroupsDetails.adult_age
                                    }}yr+)</small>
                                </div>
                                <div class="col-md-6 col-sm-5 col-6">
                                  <div class="paddb10 booking-btngrp block">
                                    <button type="button" v-on:click.prevent="removeAdult" class="vue-btnb"
                                      id="minus-vue-btn-adultsfx">
                                      <i class="fa fa-minus"></i>
                                    </button>
                                    <input disabled="disabled" class="vue-fxcount" v-model="defaultAdultNo"
                                      id="occ_adult_l" name="adultsfx" type="text" />
                                    <button type="button" v-on:click.prevent="addAdult" class="vue-btnb"
                                      id="plus-vue-btn-adultsfx">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div class="clearfix clear"></div>
                              <div class="row" style="padding-top: 10px; padding-bottom: 10px"
                                v-if="ageGroupsDetails.children_allowed != 0">
                                <div class="col-md-6 col-sm-6 col-6">
                                  <label>Children</label><small class="vue-ageDiv">({{ ageGroupsDetails.child_min_age }}
                                    -
                                    {{
                                    ageGroupsDetails.child_max_age
                                    }}yr)</small>
                                </div>
                                <div class="col-md-6 col-sm-6 col-6">
                                  <div class="paddb10 booking-btngrp block">
                                    <button type="button" v-on:click.prevent="removeChildren" class="vue-btnb"
                                      id="minus-vue-btn-childrenfx">
                                      <i class="fa fa-minus"></i>
                                    </button>
                                    <input disabled="disabled" class="vue-fxcount" v-model="defaultChildrenNo"
                                      id="occ_children_l" name="childrenfx" type="text" />
                                    <button type="button" v-on:click.prevent="addChildren" class="vue-btnb"
                                      id="plus-vue-btn-childrenfx">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                                <div class="col-md-12" v-if="children > 0">
                                  <div id="vue-ageDiv">
                                    <label id="age_label">Please select the child's age. Children
                                      are considered to be between
                                      {{ ageGroupsDetails.child_min_age }} and
                                      {{
                                      ageGroupsDetails.child_max_age
                                      }}
                                      years.</label>
                                    <div class="child_div" v-for="child in children" :key="child">
                                      <label>Child {{ child }}</label>
                                      <select id="child_1_age" name="child_1_age" class="child_ages rounded5"
                                        v-on:change="
                                          updateChildAges($event, child)
                                        ">
                                        <option value="">Age</option>
                                        <option v-for="(
                                            childrenagerange, ageindex
                                          ) in computeChildrenAgeRange(
                                            ageGroupsDetails
                                          )" :key="ageindex" :value="childrenagerange.age">
                                          {{ childrenagerange.age }} yrs
                                        </option>
                                      </select>
                                    </div>
                                    <div v-if="ageError" style="color:red">
                                      <small>Please Fill the Child {{child}} Age before adding another child</small>
                                    </div>
                                  </div>

                                </div>
                              </div>
                              <div class="clearfix clear"></div>
                              <div class="row" v-if="ageGroupsDetails.babies_allowed != 0">
                                <div class="col-md-6 col-sm-6 col-6">
                                  <label>Infants</label><small class="vue-ageDiv">(0-{{
                                    ageGroupsDetails.baby_max_age
                                    }}yr)</small>
                                </div>
                                <div class="col-md-6 col-sm-6 col-6">
                                  <div class="paddb10 booking-btngrp block">
                                    <button type="button" v-on:click.prevent="removeBabies" class="vue-btnb"
                                      id="minus-vue-btn-babiesfx">
                                      <i class="fa fa-minus"></i>
                                    </button>
                                    <input disabled="disabled" class="vue-fxcount" v-model="defaultbabiesNo"
                                      id="occ_babies_l" name="babiesfx" type="text" />
                                    <button type="button" v-on:click.prevent="addBabies" class="vue-btnb"
                                      id="plus-vue-btn-babiesfx">
                                      <i class="fa fa-plus"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div v-else class="row-fluid">
                              <div class="col-md-12 col-md-12 col-12">
                                <div id="vue-occupancy-details-text" class="hide">
                                  <div class="alert alert-warning mrgb5 paddtb5" role="alert">
                                    Guest occupancy selection in each
                                    {{ roomLabel.singular }} will be availed on
                                    the search results page.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="clearfix clear"></div>
                          <div class="col-md-12">
                            <a href="javascript:void(0);" class="pull-right" @click="close"><i class="fa fa-close"></i>
                              Close</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-md-2" v-if="multipropertyStatus == true">
                   <label>Select Room Type</label>
                    <div class="form-group" id="guests-group">
                      <select class="vue-email_screen sd"  v-model="roomType">
                        <option value="">All</option>
                        <option :value="roomtype.id" v-for="(roomtype, rtypeindex) in filteredRoomTypeArray.roomTypes" :key="rtypeindex">{{roomtype.name}}</option>
                      </select>
                    </div>
                </div> -->
                  <div class="col-md-2 vue-md_p5" v-if="clientemail">
                    <label>Email</label>
                    <div class="form-group">
                      <input id="coupon_code_largeScreen" class="vue-email_screen" v-model="email" type="email"
                        placeholder="Email address" />
                    </div>
                  </div>
                  <!-- end here -->
                  <div class="col-md-2 col-sm-4 vue-btn-wrap avail-wrap vue-md_p5"
                    v-if="multipropertyStatus == true && clientemail == true">
                    <span id="vue-havepromo" class="vue-horizontal" @click="showPromoCode">Add promo code
                    </span>
                    <div id="actPromoCodeact" v-if="showpromo || promo != ''">
                      <input type="text" id="coupon_code_largeScreen" v-model="promo"
                        class="vue-coupon_code_screen vue-horizontal" placeholder="Promo Code" />
                    </div>
                    <!-- <transition name="slide-fade"> -->
                    <!-- </transition> -->
                    <button id="vue-btn-search" v-on:click.prevent="checkAvailabilty('l')"
                      class="btn btn-md btn-orange-solid">
                      <div v-show="isSearching">
                        <span v-html="searchspinner"></span>
                      </div>
                      <div v-show="!isSearching">Check Availability</div>
                    </button>
                  </div>
                  <div class="col-md-2 col-sm-4 vue-btn-wrap avail-wrap vue-md_p5" v-else>
                    <span id="vue-havepromo" class="vue-horizontal" @click="showPromoCode">Add promo code
                    </span>
                    <div id="actPromoCodeact" v-if="showpromo || promo != ''">
                      <input type="text" id="coupon_code_largeScreen" v-model="promo"
                        class="vue-coupon_code_screen vue-horizontal" placeholder="Promo Code" />
                    </div>
                    <!-- <transition name="slide-fade"> -->
                    <!-- </transition> -->
                    <button id="vue-btn-search" v-on:click.prevent="checkAvailabilty('l')"
                      class="btn btn-md btn-orange-solid">
                      <div v-show="isSearching">
                        <span v-html="searchspinner"></span>
                      </div>
                      <div v-show="!isSearching">Check Availability</div>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container bv-example-row room-list vue-content-body" v-if="!propertyerror">
      <!-- search for small devices -->
      <div class="modal" id="modalbookingForm">
        <div class="modal-dialog">
          <div class="modal-header">
            <div class="modal-title">
              <h4>Book Your</h4>
              <h1>{{ roomLabel.plural }}</h1>
            </div>
            <button type="button" id="btn_close" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div id="vue-smallScreen" class="bookingsm" v-show="spinner">
                <div class="row">
                  <div class="col-md-12">
                    <div class="mobilelabel" v-if="multipropertyStatus == true">
                      <label>Destination</label>
                      <select class="form-control vue-small_large_select smallrooms"
                        @click="updateRoomFilter(multiproperties)" v-model="destination">
                        <option :value="initialPropertyId">{{ initialPropertyName }}</option>
                        <option :value="pdestination.id" v-for="(pdestination, destindex) in multiproperties.filter(p => p.id !== initialPropertyId)"
                          :key="destindex">
                          {{ pdestination.propertyName }}
                        </option>
                      </select>
                    </div>
                    <div class="mobilelabel">
                      <span>Arrival Date</span>
                      <CheckinDate @checkin-date-changed="checkAvailabilty('sa')"></CheckinDate>
                    </div>
                    <div class="mobilelabel">
                      <span>Departure Date</span>
                      <CheckoutDate @checkout-date-changed="checkAvailabilty('sa')"></CheckoutDate>
                    </div>
                    <div class="mobilelabel">
                      <span id="checkinlbl">Occupancy</span>
                      <select class="form-control vue-small_large_select smallrooms" v-model="room">
                        <option value="1" selected="selected">
                          1 {{ roomLabel.singular }}
                        </option>
                        <option value="2">2 {{ roomLabel.plural }}</option>
                        <option value="3">3 {{ roomLabel.plural }}</option>
                        <option value="4">4 {{ roomLabel.plural }}</option>
                        <option value="5">5 {{ roomLabel.plural }}</option>
                        <option value="6">6 {{ roomLabel.plural }}</option>
                        <option value="7">7 {{ roomLabel.plural }}</option>
                        <option value="8">8 {{ roomLabel.plural }}</option>
                        <option value="9">9 {{ roomLabel.plural }}</option>
                        <option value="10">10 {{ roomLabel.plural }}</option>
                      </select>
                      <div id="smallcapacity">
                        <select id="occ_adult_s" class="form-control vue-small_large_select" v-model="defaultAdultNo">
                          <option value="1" selected="selected">1 ADULT</option>
                          <option value="2">2 ADULTS</option>
                          <option value="3">3 ADULTS</option>
                          <option value="4">4 ADULTS</option>
                          <option value="5">5 ADULTS</option>
                          <option value="6">6 ADULTS</option>
                          <option value="7">7 ADULTS</option>
                          <option value="8">8 ADULTS</option>
                          <option value="9">9 ADULTS</option>
                          <option value="10">10 ADULTS</option>
                        </select>

                        <select id="occ_children_s" class="form-control vue-small_large_select"
                          v-model="defaultChildrenNo" v-if="ageGroupsDetails.children_allowed != 0">
                          <option value="0" selected="selected">0 CHILDREN</option>
                          <option value="1">1 CHILD</option>
                          <option value="2">2 CHILDREN</option>
                          <option value="3">3 CHILDREN</option>
                          <option value="4">4 CHILDREN</option>
                          <option value="5">5 CHILDREN</option>
                          <option value="6">6 CHILDREN</option>
                          <option value="7">7 CHILDREN</option>
                          <option value="8">8 CHILDREN</option>
                          <option value="9">9 CHILDREN</option>
                          <option value="10">10 CHILDREN</option>
                        </select>
                        <div>
                          <div class="col-md-12" v-if="children > 0">
                            <div id="vue-ageDiv">
                              <label id="age_label">Please select the child's age. Children
                                are considered to be between
                                {{ ageGroupsDetails.child_min_age }} and
                                {{
                                ageGroupsDetails.child_max_age
                                }}
                                years.</label>
                              <div class="child_div" v-for="child in children" :key="child">
                                <label>Child {{ child }}</label>
                                <select id="child_1_age" name="child_1_age" class="child_ages rounded5" v-on:change="
                                          updateChildAges($event, child)
                                        ">
                                  <option value="">Age</option>
                                  <option v-for="(
                                            childrenagerange, ageindex
                                          ) in computeChildrenAgeRange(
                                            ageGroupsDetails
                                          )" :key="ageindex" :value="childrenagerange.age">
                                    {{ childrenagerange.age }} yrs
                                  </option>
                                </select>
                              </div>

                            </div>
                            <div v-if="ageError" style="color:red">
                              <small>Please Fill the Child(ren) Age(s)</small>
                            </div>

                          </div>
                        </div>
                        <select id="occ_babies_s" class="form-control vue-small_large_select" v-model="defaultbabiesNo"
                          v-if="ageGroupsDetails.babies_allowed != 0">
                          <option value="0" selected="selected">0 BABIES</option>
                          <option value="1">1 BABY</option>
                          <option value="2">2 BABIES</option>
                          <option value="3">3 BABIES</option>
                          <option value="4">4 BABIES</option>
                          <option value="5">5 BABIES</option>
                          <option value="6">6 BABIES</option>
                          <option value="7">7 BABIES</option>
                          <option value="8">8 BABIES</option>
                          <option value="9">9 BABIES</option>
                          <option value="10">10 BABIES</option>
                        </select>
                      </div>
                    </div>
                    <div class="mobilelabel" v-if="clientemail">
                      <span id="emaillbl">Your Email</span>
                      <input id="email_vue-smallScreen" class="vue-email_screen input-clearbg"
                        placeholder="Your email address" type="text" v-model="email" />
                    </div>
                    <div class="mobilelabel">
                      <span class="mobilelabel">Promo Code</span>
                      <input type="text" id="coupon_code_vue-smallScreen" class="form-control coupon_code_screen"
                        placeholder="Promo code" v-model="promo" />
                    </div>
                    <button id="vue-btn-search-mobile" v-on:click.prevent="checkAvailabilty('s')"
                      @click="scrollToElement" class="btn btn-orange-solid">
                      <div v-show="isSearching">
                        <span v-html="searchspinner"></span>
                      </div>
                      <div v-show="!isSearching">Check Availability</div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- section to show available properties -->
      <div class="container bv-example-row room-list vue-content-body" v-if="!loadResult">
        <!-- form -->
        <!-- end search -->
        <div class="row">
          <div class="act-overlay" v-show="!spinner">
            <loader-terms></loader-terms>
          </div>
        </div>
        <!-- {{multiproperties}} -->
        <div>
          <div class="row section-content">
            <div class="col-md-12 col-sm-12 col-12">
              <div class="vue-card-columns card-columns card_content">
                <!-- {{soffer}} -->
                <div class="vue-card" v-for="(property, sindex) in paginatedData" :key="sindex">
                  <img class="card-img-top property_image" loading="lazy"
                    :src="property.propertyLogo !==''? property.propertyLogo :'https://reservations.reserveport.com/offers/static/img/noimages.jpg'"
                    alt="Card image" />
                  <!-- <img class="card-img-top"  src="https://reservations.reserveport.com/offers/static/img/noimages.jpg" alt="Card image" style="width:100%;height:270px;"> -->
                  <div class="vue-card-body">
                    <h4 class="card-title" @click="redirectToListBooking(property.id)">
                      {{ property.propertyName }}
                    </h4>
                    <div>
                      <!-- {{soffer}} -->
                    </div>
                    <div>
                      <div :id="'lesstext' + property.id" style="display: block">
                        <div v-if="property.propertyDescription != ''"
                          v-html="property.propertyDescription.slice(0, 180)"></div>
                        <span class="startingfrom" @click="activateReadMore(property.id)">read more...</span>
                        <br />
                      </div>
                      <div :id="'moretext' + property.id" style="display: none">
                        <div v-html="property.propertyDescription"></div>
                        <span class="startingfrom" @click="activateReadLess(property.id)">read less</span>
                        <br />
                      </div>
                      <!-- {{soffer}} -->
                    </div>
                    <div>
                      <span class="vue-from">From</span> <br />
                      <div v-if="
                          property.currencyRes != 0 &&
                          property.currencyRes != ''
                        " class="rates">
                        <span class="vue-prices">{{ property.currencyRes }}
                          {{ formatPrice(property.startingFromPrice.res)
                          }}<span> / Night</span></span>
                        <br /><br />
                      </div>
                      <div v-else>
                        <span class="vue-prices">{{ property.currencyNonRes }}
                          {{ formatPrice(property.startingFromPrice.nonres)
                          }}<span> / Night</span></span>
                        <br /><br />
                      </div>
                    </div>
                    <button type="submit" class="
                        btn
                        align-self-end
                        btn-orange-solid
                        text-truncate
                        mt-auto
                      " @click="redirectToListBooking(property.id)" style="margin-top: auto">
                      Explore
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row pull-right section-content" v-if="pageCount > 1">
            <span @click="prevPage" style="margin-right: 15px"><i class="fa fa-angle-left"
                style="font-size: 30px"></i></span>
            <span style="font-size: 20px">{{ currentPage }} / {{ pageCount }}</span>
            <span @click="nextPage" style="margin-left: 15px"><i class="fa fa-angle-right"
                style="font-size: 30px"></i></span>
          </div>
        </div>
      </div>
      <!-- end multiproperty -->
      <div class="row" v-show="spinner" v-if="!residenceTab && loadResult">
        <div class="col-md-12 col-sm-12 col-12">
          <div class="residencydiv">
            <div class="vue-btn-group pull-left" id="vue-toggle_residency">
              <button type="button" id="btnres" class="res_vue-btn vue-btn-res vue-btn btn active"
                @click.prevent="localResident()">
                Resident
              </button>
              <button type="button" id="btnnonres" class="nonres_vue-btn vue-btn-non-res btn vue-btn"
                @click.prevent="nonResident()">
                Non-Resident
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-4" v-if="guestFormSettings.proof_of_residency_selection == 1 && proof">
        <div class="col-md-12 col-sm-12 col-12">
          <div id="proof">
            <transition name="slide-fade">
              <span class="pull-right">Proof of residency will be required upon check-in.</span>
            </transition>
          </div>
        </div>
      </div>
      <!-- body -->
      <div class="row" v-if="availableRates" v-show="loadResult">
        <div class="col-md-9 col-sm-12 col-12">
          <div class="row">
            <div class="act-overlay" v-show="!spinner">
              <loader-terms></loader-terms>
            </div>
          </div>
          <div class="vue-card-unit" v-for="(booking, bindex) in bookingData.rooms" :key="bindex" v-show="spinner">
            <div class="vue-card-unit-title">
              <span class="room-title"
                @click="gotoRoomDetail(booking.id, booking.availability.available, booking.availability.allowOnlineBookings == 1)"
                style="cursor: pointer">{{ booking.name }}</span><span style="color: #bd362f"
                v-if="booking.availability.available == 0">(SOLD OUT)</span>
              <span v-if="booking.lastBooked !== ''" class="availability_text">{{ booking.lastBooked }}</span>
            </div>
            <div>
              <div class="row">
                <div class="col-md-4 col-sm-12 col-12">
                  <div class="room-thumb" v-if="booking.images && booking.images.length">
                    <div class="room-thumb-track"
                      :style="{ transform: 'translateX(-' + ((roomImageIndex[bindex] || 0) * 100) + '%)' }">
                      <img v-for="(img, imgIndex) in booking.images" :key="imgIndex" :src="img" :alt="booking.name"
                        class="room-thumb-img" />
                    </div>
                    <template v-if="booking.images.length > 1">
                      <button type="button" class="room-thumb-nav room-thumb-nav-prev"
                        @click.prevent="changeRoomImage(bindex, booking.images.length, -1)" aria-label="Previous image">
                        <i class="fa fa-angle-left"></i>
                      </button>
                      <button type="button" class="room-thumb-nav room-thumb-nav-next"
                        @click.prevent="changeRoomImage(bindex, booking.images.length, 1)" aria-label="Next image">
                        <i class="fa fa-angle-right"></i>
                      </button>
                      <span class="room-thumb-counter">{{ (roomImageIndex[bindex] || 0) + 1 }}/{{ booking.images.length }}</span>
                    </template>
                  </div>
                  <div class="room-thumb" v-else>
                    <img src="https://reservations.reserveport.com/offers/static/img/noimages.jpg" :alt="booking.name"
                      class="room-thumb-img" />
                  </div>
                </div>
                <div class="col-md-8 col-sm-12 col-12">
                  <div v-if="booking.availability.allowOnlineBookings == 1">
                    <div v-for="board in booking.boards" :key="board.name" class="vue-pad-content">
                      <div v-if="
                          (bookingData.currency.res != '' &&
                            board.roomPrice.res != 0) ||
                          (bookingData.currency.nonres != '' &&
                            board.roomPrice.nonres != 0)
                        ">
                        <div class="vue-border-btm">
                          <div class="row">
                            <div class="col-md-4 col-sm-3 col-12 col-7">
                              <span class="text-center-sm text-center-xs">
                                <i class="fa fa-check"></i>
                                <strong> {{ board.name }}</strong>
                              </span>
                              <div>
                                <i class="small">{{ board.description }}</i>
                              </div>
                            </div>
                            <div class="col-md-2 col-sm-2 col-12 col-5">
                              <span v-for="n in adult" :key="n">
                                <i class="fa fa-user" style="font-size: 14px"></i>
                              </span>
                              <span v-if="children > 0">
                                <span v-for="d in children" :key="d">
                                  <i class="fa fa-user" style="font-size: 10px"></i>
                                </span>
                              </span>
                            </div>
                            <div class="col-md-3 col-sm-3 col-12 col-6" v-if="booking.availability.available !== 0"
                              id="priceDetail">
                              <!-- resident -->
                              <div v-if="proofRes == 0">
                                <div v-if="board.roomDiscount.res == 0">
                                  <strong>{{ bookingData.currency.res }}
                                    {{
                                    formatPrice(board.roomPrice.res)
                                    }} </strong><br />
                                </div>
                                <div v-else>
                                  <small>
                                    <strong>
                                      <strike style="color: #a81414">{{ bookingData.currency.res }} &nbsp;
                                        {{ formatPrice(board.roomPrice.res) }}
                                      </strike>
                                    </strong>
                                  </small>
                                  <br />
                                  <strong>{{ bookingData.currency.res }} &nbsp;
                                    {{
                                    formatPrice(
                                    board.roomPriceAfterDiscount.res
                                    )
                                    }}</strong><br />
                                </div>
                              </div>
                              <!-- endresident -->
                              <!-- non resident -->
                              <div v-if="proofRes == 1">
                                <div v-if="board.roomDiscount.nonres == 0">
                                  <strong>{{ bookingData.currency.nonres }}
                                    {{
                                    formatPrice(board.roomPrice.nonres)
                                    }} </strong><br />
                                </div>
                                <div v-else>
                                  <small>
                                    <strong>
                                      <strike style="color: #a81414">{{
                                        bookingData.currency.nonres
                                        }}
                                        &nbsp;
                                        {{
                                        formatPrice(board.roomPrice.nonres)
                                        }}
                                      </strike>
                                    </strong> </small><br />
                                  <strong>{{ bookingData.currency.nonres }} &nbsp;
                                    {{
                                    formatPrice(
                                    board.roomPriceAfterDiscount.nonres
                                    )
                                    }}</strong><br />
                                </div>
                              </div>
                              <!-- end resident -->
                              <span class="small"><strong>for {{ period }} {{ periodText }}</strong></span><br />
                              <span class="small">{{ bookingData.vat.room_price }} of taxes</span>
                            </div>
                            <div class="col-md-3 col-sm-3 col-12" v-if="
                                bookingData.guest_form_settings
                                  .proof_of_residency_popup == 0 &&
                                booking.availability.available !== 0
                              ">
                              <button class="btn btn-orange-solid" id="vue-btn" :disabled="clicked" @click.prevent="
                                  redirectToBookDetail(booking, board)
                                " data-toggle="dataToggle" data-placement="top" :title="errMsg">
                                Book Now
                              </button>
                            </div>
                            <div class="col-md-3 col-sm-3 col-12 col-6" v-if="
                                bookingData.guest_form_settings
                                  .proof_of_residency_popup == 1 &&
                                booking.availability.available !== 0
                              ">
                              <button data-toggle="modal" data-target="#proffmodalpopup" id="vue-btn"
                                class="btn btn-orange-solid" v-if="resident == 'resident'" :disabled="clicked"
                                @click="openProofModal(booking, board)">
                                Book Now
                              </button>
                              <button id="vue-btn" class="btn btn-orange-solid" @click.prevent="
                                  redirectToBookDetail(booking, board)
                                " v-if="resident == 'non-resident'" :disabled="clicked" data-toggle="dataToggle"
                                data-placement="top" :title="errMsg">
                                Book Now
                              </button>
                            </div>
                            <div class="col-md-6 col-sm-3 col-12" v-if="booking.availability.available == 0"
                              id="priceDetail">
                              <!-- resident -->
                              <div v-if="proofRes == 0">
                                <div v-if="board.roomDiscount.res == 0">
                                  <strong>{{ bookingData.currency.res }}
                                    {{
                                    formatPrice(board.roomPrice.res)
                                    }} </strong><br />
                                </div>
                                <div v-else>
                                  <small>
                                    <strong>
                                      <strike style="color: #a81414">{{ bookingData.currency.res }} &nbsp;
                                        {{ formatPrice(board.roomPrice.res) }}
                                      </strike>
                                    </strong>
                                  </small>
                                  <br />
                                  <strong>{{ bookingData.currency.res }} &nbsp;
                                    {{
                                    formatPrice(
                                    board.roomPriceAfterDiscount.res
                                    )
                                    }}</strong><br />
                                </div>
                              </div>
                              <!-- endresident -->
                              <!-- non resident -->
                              <div v-if="proofRes == 1">
                                <div v-if="board.roomDiscount.nonres == 0">
                                  <strong>{{ bookingData.currency.nonres }}
                                    {{
                                    formatPrice(board.roomPrice.nonres)
                                    }} </strong><br />
                                </div>
                                <div v-else>
                                  <small>
                                    <strong>
                                      <strike style="color: #a81414">{{
                                        bookingData.currency.nonres
                                        }}
                                        &nbsp;
                                        {{
                                        formatPrice(board.roomPrice.nonres)
                                        }}
                                      </strike>
                                    </strong> </small><br />
                                  <strong>{{ bookingData.currency.nonres }} &nbsp;
                                    {{
                                    formatPrice(
                                    board.roomPriceAfterDiscount.nonres
                                    )
                                    }}</strong><br />
                                </div>
                              </div>
                              <!-- end resident -->
                              <span class="small"><strong>for {{ period }} {{ periodText }}</strong></span><br />
                              <span class="small">{{ bookingData.vat.room_price }} of taxes</span>
                            </div>
                            <!-- modal for proof of residency pop -->
                            <div class="modal" id="proffmodalpopup">
                              <div class="modal-dialog">
                                <div class="modal-content">
                                  <!-- Modal body -->
                                  <div class="proof_modal_body">
                                    Dear Guest, <br /><br />
                                    <p>
                                      Please note that you have selected
                                      resident rates
                                    </p>
                                    <p>
                                      As per company policies proof of residency
                                      will be required upon check-in
                                    </p>
                                    <div class="proof_modal_list">
                                      <ul>
                                        <li>
                                          If you do confirm that you are a
                                          resident kindly click 'OK' to proceed
                                          with your booking
                                        </li>
                                        <li>
                                          If you are a non-resident, kindly
                                          click 'CANCEL' and use the
                                          resident/non-resident tabs to switch
                                          to the non-resident portal
                                        </li>
                                      </ul>
                                    </div>
                                  </div>

                                  <!-- Modal footer -->
                                  <div class="modal-footer">
                                    <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
                                      <div class="btn-group mr-2" role="group" aria-label="Second group">
                                        <button type="button" id="vue-btn" class="btn btn-outline" data-dismiss="modal">
                                          Cancel
                                        </button>
                                      </div>
                                      <div class="btn-group" role="group" aria-label="Third group">
                                        <button type="button" class="btn btn-solid" id="vue-btn" @click.prevent="
                                            redirectToBookDetail(
                                              bookingDataProof,
                                              boardDataProof
                                            )
                                          " data-dismiss="modal">
                                          OK
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- end -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- contacts for online not enabled scenario -->
                  <div v-else class="vue-pad-content">
                    <div class="alert alert-warning mrgtb20 paddtb10" role="alert"
                      v-if="booking.availability.available !== 0">
                      <span class="fa fa-bell-o faa-ring animated"></span>
                      Please send an email
                      to
                      <a :href="'mailto:' + bookingData.contactDetails.mainEmail">{{
                        bookingData.contactDetails.mainEmail }}</a>
                      to reserve this room.
                    </div>
                    <div v-for="board in booking.boards" :key="board.name" class="vue-pad-content"
                      v-if="booking.availability.available !== 0 && booking.availability.allowOnlineBookings == 2">
                      <div v-if="(bookingData.currency.res != '' &&
                                              board.roomPrice.res != 0) ||
                                            (bookingData.currency.nonres != '' &&
                                              board.roomPrice.nonres != 0)
                                            ">
                        <div class="vue-border-btm">
                          <div class="row">
                            <div class="col-md-5 col-sm-3 col-12 col-7">
                              <span class="text-center-sm text-center-xs">
                                <i class="fa fa-check"></i>
                                <strong> {{ board.name }}</strong>
                              </span>
                              <div>
                                <i class="small">{{ board.description }}</i>
                              </div>
                            </div>
                            <div class="col-md-3 col-sm-2 col-12 col-5">
                              <span v-for="n in adult" :key="n">
                                <i class="fa fa-user" style="font-size: 14px"></i>
                              </span>
                              <span v-if="children > 0">
                                <span v-for="d in children" :key="d">
                                  <i class="fa fa-user" style="font-size: 10px"></i>
                                </span>
                              </span>
                            </div>
                            <div class="col-md-3 col-sm-3 col-12 col-6" v-if="booking.availability.available !== 0"
                              id="priceDetail">
                              <!-- resident -->
                              <div v-if="proofRes == 0">
                                <div v-if="board.roomDiscount.res == 0">
                                  <strong>{{ bookingData.currency.res }}
                                    {{
                                    formatPrice(board.roomPrice.res)
                                    }} </strong><br />
                                </div>
                                <div v-else>
                                  <small>
                                    <strong>
                                      <strike style="color: #a81414">{{ bookingData.currency.res }} &nbsp;
                                        {{ formatPrice(board.roomPrice.res) }}
                                      </strike>
                                    </strong>
                                  </small>
                                  <br />
                                  <strong>{{ bookingData.currency.res }} &nbsp;
                                    {{
                                    formatPrice(
                                    board.roomPriceAfterDiscount.res
                                    )
                                    }}</strong><br />
                                </div>
                              </div>
                              <!-- endresident -->
                              <!-- non resident -->
                              <div v-if="proofRes == 1">
                                <div v-if="board.roomDiscount.nonres == 0">
                                  <strong>{{ bookingData.currency.nonres }}
                                    {{
                                    formatPrice(board.roomPrice.nonres)
                                    }} </strong><br />
                                </div>
                                <div v-else>
                                  <small>
                                    <strong>
                                      <strike style="color: #a81414">{{
                                        bookingData.currency.nonres
                                        }}
                                        &nbsp;
                                        {{
                                        formatPrice(board.roomPrice.nonres)
                                        }}
                                      </strike>
                                    </strong> </small><br />
                                  <strong>{{ bookingData.currency.nonres }} &nbsp;
                                    {{
                                    formatPrice(
                                    board.roomPriceAfterDiscount.nonres
                                    )
                                    }}</strong><br />
                                </div>
                              </div>
                              <!-- end resident -->
                              <span class="small"><strong>for {{ period }} {{ periodText }}</strong></span><br />
                              <span class="small">{{ bookingData.vat.room_price }} of taxes</span>
                            </div>
                            <div class="col-md-6 col-sm-3 col-12" v-if="booking.availability.available == 0"
                              id="priceDetail">
                              <!-- resident -->
                              <div v-if="proofRes == 0">
                                <div v-if="board.roomDiscount.res == 0">
                                  <strong>{{ bookingData.currency.res }}
                                    {{
                                    formatPrice(board.roomPrice.res)
                                    }} </strong><br />
                                </div>
                                <div v-else>
                                  <small>
                                    <strong>
                                      <strike style="color: #a81414">{{ bookingData.currency.res }} &nbsp;
                                        {{ formatPrice(board.roomPrice.res) }}
                                      </strike>
                                    </strong>
                                  </small>
                                  <br />
                                  <strong>{{ bookingData.currency.res }} &nbsp;
                                    {{
                                    formatPrice(
                                    board.roomPriceAfterDiscount.res
                                    )
                                    }}</strong><br />
                                </div>
                              </div>
                              <!-- endresident -->
                              <!-- non resident -->
                              <div v-if="proofRes == 1">
                                <div v-if="board.roomDiscount.nonres == 0">
                                  <strong>{{ bookingData.currency.nonres }}
                                    {{
                                    formatPrice(board.roomPrice.nonres)
                                    }} </strong><br />
                                </div>
                                <div v-else>
                                  <small>
                                    <strong>
                                      <strike style="color: #a81414">{{
                                        bookingData.currency.nonres
                                        }}
                                        &nbsp;
                                        {{
                                        formatPrice(board.roomPrice.nonres)
                                        }}
                                      </strike>
                                    </strong> </small><br />
                                  <strong>{{ bookingData.currency.nonres }} &nbsp;
                                    {{
                                    formatPrice(
                                    board.roomPriceAfterDiscount.nonres
                                    )
                                    }}</strong><br />
                                </div>
                              </div>
                              <!-- end resident -->
                              <span class="small"><strong>for {{ period }} {{ periodText }}</strong></span><br />
                              <span class="small">{{ bookingData.vat.room_price }} of taxes</span>
                            </div>
                            <!-- modal for proof of residency pop -->
                            <div class="modal" id="proffmodalpopup">
                              <div class="modal-dialog">
                                <div class="modal-content">
                                  <!-- Modal body -->
                                  <div class="proof_modal_body">
                                    Dear Guest, <br /><br />
                                    <p>
                                      Please note that you have selected
                                      resident rates
                                    </p>
                                    <p>
                                      As per company policies proof of residency
                                      will be required upon check-in
                                    </p>
                                    <div class="proof_modal_list">
                                      <ul>
                                        <li>
                                          If you do confirm that you are a
                                          resident kindly click 'OK' to proceed
                                          with your booking
                                        </li>
                                        <li>
                                          If you are a non-resident, kindly
                                          click 'CANCEL' and use the
                                          resident/non-resident tabs to switch
                                          to the non-resident portal
                                        </li>
                                      </ul>
                                    </div>
                                  </div>

                                  <!-- Modal footer -->
                                  <div class="modal-footer">
                                    <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
                                      <div class="btn-group mr-2" role="group" aria-label="Second group">
                                        <button type="button" id="vue-btn" class="btn btn-outline" data-dismiss="modal">
                                          Cancel
                                        </button>
                                      </div>
                                      <div class="btn-group" role="group" aria-label="Third group">
                                        <button type="button" class="btn btn-solid" id="vue-btn" @click.prevent="
                                                                                redirectToBookDetail(
                                                                                  bookingDataProof,
                                                                                  boardDataProof
                                                                                )
                                                                                " data-dismiss="modal">
                                          OK
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- end -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="vue-card-unit-summary">
                    <div class="row">
                      <div class="col-md-12">
                        <ul class="vue-mrg0">
                          <li class="mrgb10" v-if="booking.availability.available == 0">
                            <div class="soldoutdates">
                              <label class="soldout-lbl">Sold Out on</label>
                              <div v-for="(soldoutdate, soldindex) in booking
                                  .availability.soldOutDates" :key="soldindex" style="display: inline">
                                <span class="soldoutspan">{{
                                  soldoutdate
                                  }}</span>
                              </div>
                            </div>
                          </li>
                          <li class="mrgb10" v-if="
                              Object.keys(booking.discount_coupons).length !== 0
                            ">
                            <div class="row vue-specialoffer">
                              <div class="col-md-12" v-for="(
                                  bdiscount, bindex
                                ) in booking.discount_coupons" :key="bindex">
                                <i class="fa fa-tag"></i><span> {{ bdiscount.code }}</span><br />
                                <small><strong>Applicable Boards:</strong>
                                  <span>{{ bdiscount.boards }}</span> </small><br /><small>
                                  <strong>Coupon Code: </strong>
                                  {{ bdiscount.code }}</small><br /><small>
                                  <strong>Applicable dates: </strong>
                                  {{ bdiscount.start_date }} To
                                  {{ bdiscount.end_date }}</small><br /><small>
                                  <strong>Promo Type: </strong>
                                  {{ bdiscount.type }}</small>
                              </div>
                            </div>
                          </li>
                          <li class="mrgb10">
                            <div class="row availablityroomdetail" v-if="
                                booking.availability.allowOnlineBookings == 1
                              ">
                              <div class="col-md-12">
                                <div v-if="
                                    booking.availability.available <=
                                      booking.availability.alertLimit &&
                                    booking.availability.available > 0
                                  ">
                                  <span style="color: #cc0000"><span v-if="booking.availability.available > 1">{{
                                      booking.availability.available }}
                                      {{ roomLabel.plural }}</span>
                                    <span v-else>
                                      Only {{ booking.availability.available }}
                                      {{ roomLabel.singular }}</span>
                                    like this left in our property</span>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li class="mrgb10">
                            <span><b>Number of adults</b></span>: {{ booking.occupancy.maximumAdultOccupancy }} Max
                          </li>

                          <li class="mrgb10">
                            <span v-if="ageGroupsDetails.babies_allowed != 0"><strong>Infants: </strong>below
                              {{ ageGroupsDetails.baby_max_age }} years |</span>
                            <span v-if="ageGroupsDetails.children_allowed != 0"><strong>Children: </strong>{{
                              ageGroupsDetails.child_min_age }} -
                              {{ ageGroupsDetails.child_max_age }} years |</span>
                            <strong>Adult: </strong>
                            {{ ageGroupsDetails.adult_age }} years and above
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="clear clearfix"></div>
                  <div class="vue-card-unit-footer">
                    <div class="row">
                      <div class="col-md-12">
                        <span class="uppercase vue-show-details" id="vue-show-details-1410"
                          v-if="booking.description !== ''" @click="rdetail(booking.id)">{{ roomLabel.singular }}
                          details</span>
                        <span class="sep" v-if="bookingData.description !== '' && bookingData.terms !== ''">|</span>
                        <span id="vue-show-tc-1410" href="#" v-if="bookingData.terms !== ''"
                          class="uppercase vue-show-tc" @click="termCondition(booking.id)">Terms and conditions</span>
                        <span class="sep"
                          v-if="bookingData.cancellation_policies !== '' && bookingData.terms !== '' || bookingData.description !== '' && bookingData.terms !== ''">|</span>
                        <span id="vue-show-tc-1410" v-if="bookingData.cancellation_policies !== ''" href="#"
                          class="uppercase vue-show-tc" @click="cancPolicy(booking.id)">Cancellation policies</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--child-->
            <div class="row">
              <div class="col-md-12 col-sm-12 col-12">
                <transition name="slide-fade">
                  <div class="vue-card-unit-description" v-if="descr == booking.id">
                    <span class="uppercase"><strong> {{ roomLabel.singular }} Details</strong></span>
                    <div v-html="booking.description"></div>
                    <ul class="vue-features-list">
                      <li class="feat vue-non-icons" v-for="(feature, index) in booking.features" :key="index">
                        <i class="fa fa-check"></i> {{ feature.name }}
                      </li>
                    </ul>
                  </div>
                  <div class="vue-card-unit-description" v-if="term == booking.id">
                    <span class="uppercase"><strong>Terms and conditions</strong></span>
                    <div v-html="bookingData.terms"></div>
                  </div>
                  <div class="vue-card-unit-description" v-if="canc == booking.id">
                    <span class="uppercase"><strong> Cancellation Policies</strong></span>
                    <div v-html="bookingData.cancellation_policies"></div>
                  </div>
                </transition>
              </div>
            </div>
            <!-- break is here -->
          </div>
        </div>

        <div class="col-md-3 col-sm-12 col-12" v-show="spinner">
          <div class="vue-right-side">
            <div class="row">
              <div class="col-md-12">
                <div class="vue-side_top_card">
                  <h3>
                    {{ bookingData.name }}
                  </h3>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="vue-side_bottom_card">
                  <h3>SUMMARY</h3>
                  <!-- <i class="fa fa-bed fa-4x"></i> -->
                  <div>
                    <div id="no_room_selected" class="no-roomdiv vue-block">
                      <img id="no_room_selected_img" loading="lazy"
                        :src="'https://reservations.reserveport.com/static/img/bed.png'" width="90" />
                      <h4 id="no-rooms">
                        No {{ roomLabel.singular }} Selected
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="sopaginatedData.length > 0" v-show="bookingData.show_coupon_ads == 1">
              <div class="col-md-12">
                <div class="vue-offers-card">
                  <div v-for="(soffer, sindex) in sopaginatedData" :key="sindex">
                    <img class="card-img-top vue-responsive" style="cursor: pointer" @click="submitOffer"
                      :src="soffer.image ? soffer.image : 'https://reservations.reserveport.com/offers/static/img/noimages.jpg'"
                      loading="lazy" alt="Card image" />
                    <div class="vue-offers-card-body">
                      <h4 class="card-title" style="cursor: pointer" @click="submitOffer">
                        {{ soffer.couponCode }}
                      </h4>
                      <div v-if="soffer.type == 'rateoveride'">
                        <small class="startingfrom">Price starts from </small>
                        <div v-if="
                            soffer.currencyRes != 0 && soffer.currencyRes != ''
                          " class="rates">
                          <span v-if="soffer.adultRate.res > 0"><strong>{{ soffer.currencyRes }}
                              {{ soffer.adultRate.res }}</strong></span>
                          <span v-else><strong>{{ soffer.currencyRes }}
                              {{ soffer.childRate.res }}</strong></span>
                        </div>
                        <div v-else>
                          <span v-if="soffer.adultRate.nonres > 0"><strong>{{ soffer.currencyNonRes }}
                              {{ soffer.adultRate.nonres }}</strong></span>
                          <span v-else><strong>{{ soffer.currencyNonRes }}
                              {{ soffer.childRate.nonres }}</strong></span>
                        </div>
                      </div>
                      <div v-if="soffer.type == 'discount_percentage'">
                        <small class="startingfrom">Discount </small>
                        <span><strong>{{ soffer.discountRes }} %</strong></span>
                      </div>
                      <div v-if="soffer.type == 'discount_flatrate'">
                        <small class="startingfrom">Discount </small>
                        <div v-if="
                            soffer.currencyRes != 0 && soffer.currencyRes != ''
                          " class="rates">
                          <span><strong>{{ soffer.currencyRes }}
                              {{ soffer.discountRes }}</strong></span>
                        </div>
                        <div v-else class="rates">
                          <span><strong>{{ soffer.currencyNonRes }}
                              {{ soffer.discountNonRes }}</strong></span>
                        </div>
                      </div>
                      <div></div>
                      <br />
                      <form :action="soffer.embedLink" method="get" id="vueofferForm">
                        <input type="hidden" name="pid" :value="soffer.propertyId" />
                        <input type="hidden" name="checkin_date" :value="getCheckinDate(soffer.startDate)" />
                        <input type="hidden" name="checkout_date" :value="
                            getCheckoutDate(soffer.startDate, soffer.minNights)
                          " />
                        <input type="hidden" name="adults" value="1" />
                        <input type="hidden" :value="soffer.couponCode" name="coupon_code" />
                        <button type="submit" class="btn btn-orange-solid" style="margin-top: auto">
                          Book Now
                        </button>
                      </form>
                    </div>
                  </div>
                  <div class="section-content" v-if="sopageCount > 1" style="text-align: right">
                    <span @click="soprevPage" style="margin-right: 15px; cursor: pointer"><i
                        class="fa fa-angle-left"></i></span>
                    <span>{{ socurrentPage }} / {{ sopageCount }}</span>
                    <span @click="sonextPage" style="margin-left: 15px; cursor: pointer"><i
                        class="fa fa-angle-right"></i></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container" v-else>
        <div class="alert alert-danger">
          <strong>No available rates </strong>
        </div>
      </div>
      <!-- endbody -->
    </div>
    <div class="mobile_booking_wrapper">
      <button class="mobile_booking_dates" id="mobile_booking_triger" data-toggle="modal"
        data-target="#modalbookingForm">
        <i class="fa fa-calendar-o mobile_booking_dates_icon" aria-hidden="true"></i>
        <span class="mobile_booking_date_segment">
          <span class="mobile_booking_date_label">Check-in</span>
          <span class="mobile_booking_date_value">{{ mobileCheckinLabel }}</span>
        </span>
        <span class="mobile_booking_date_divider"></span>
        <span class="mobile_booking_date_segment">
          <span class="mobile_booking_date_label">Check-out</span>
          <span class="mobile_booking_date_value">{{ mobileCheckoutLabel }}</span>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import loader from '../components/loader.vue'
import moment from 'moment'
import reusableData from '../components/mixins/reusableData'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { mapState } from 'vuex'
import CheckinDate from './dates/checkinDate.vue'
import CheckoutDate from './dates/checkoutDate.vue'

export default {
  name: 'Booking',
  props: ['data'],
  components: {
    'loader-terms': loader,
    'date-picker': DatePicker,
    CheckinDate, CheckoutDate
  },
  data () {
    return {
      errors: false,
      errorMsg: [],
      offers: [],
      currentPage: 1,
      size: 6,
      residenceTab: false,
      propertyerror: false,
      errormsg: '',
      checkoutdate1: '',
      canc: null,
      checkdate: '',
      consumerKey: '',
      resident: 'resident',
      propertyid: '',
      childAges: [],
      isSearching: false,
      searchspinner: "<i class='fa fa-spinner fa-spin '></i> SEARCHING",
      promoCode: false,
      period: '',
      periodText: 'night',
      spinner: false,
      bookings: this.$store.state.bookings,
      descr: null,
      term: null,
      proof: false,
      proofRes: 0,
      guestOccupancy: 1,
      url: null,
      destination: '',
      occupancy: '',
      email: '',
      guest: 1,
      room: 1,
      promo: '',
      adult: 1,
      defaultAdultNo: 1,
      defaultChildrenNo: 0,
      defaultbabiesNo: 0,
      babies: 0,
      children: 0,
      roomImageIndex: {},
      bookingDataProof: null,
      boardDataProof: null,
      postdataparamtest: null,
      multiproperties: [],
      filteredRoomTypeArray: '',
      roomType: '',
      multipropertyStatus: false,
      clientemail: false,
      ageGroupsDetails: '',
      bookingData: '',
      guestFormSettings: '',
      roomData: '',
      availableRates: true,
      loadResult: false,
      currentImages: {},
      imageindex: 0,
      socurrentPage: 1,
      sosize: 1,
      showpromo: false,
      roomLabel: '',
      clicked: false,
      listing: '',
      ageError: false,
      dateChanged: false,
      dataToggle: '',
      errMsg: '',
      nonRefundable: false
    }
  },
  beforeMount: async function () {
    if (this.$root.occupancy !== undefined && this.$root.occupancy !== '') {
      this.adult = parseInt(this.$root.occupancy)
      this.defaultAdultNo = parseInt(this.$root.occupancy)
    }
    // check if coupon code is passed in widget
    if (this.$root.coupon_code !== undefined && this.$root.coupon_code !== '') {
      this.promo = this.$root.coupon_code
    }
    if (this.$root.clientemail === undefined) {
      this.clientemail = false
    } else if (this.$root.clientemail !== '') {
      this.clientemail = this.$root.clientemail
    }
    this.getDateDataFromUrl()
    this.getUrlData()
    this.fetchData()
    // this.multipropertyStatus = this.$root.multiproperty
    if (this.multipropertyStatus === true) {
      this.gettingMultiProperties()
    }
    this.guest = parseInt(this.adult) + parseInt(this.children) + parseInt(this.babies)
    setInterval(() => this.nextPage(), 60000)

    const pageAccessedByReload = (
      (window.performance.navigation && window.performance.navigation.type === 1) ||
        window.performance
          .getEntriesByType('navigation')
          .map((nav) => nav.type)
          .includes('reload')
    )
    if (pageAccessedByReload) {
      this.dateChanged = false
    }
  },
  watch: {
    chckInDate () {
      if (this.dateChanged) {
        let nextDate = this.chckInDate// event.target.value
        let stayrestrictions = this.bookings.data[this.propertyid].stay_restrictions
        if (stayrestrictions.length > 0) {
          for (const stayrestriction of stayrestrictions) {
            var startdate = moment(stayrestriction.start_date).subtract(1, 'days').format('YYYY-MM-DD')
            var enddate = moment(stayrestriction.end_date).add(1, 'days').format('YYYY-MM-DD')
            if (moment(this.chckInDate).isBetween(startdate, enddate) === true) {
              var minNights = stayrestriction.minimum_nights
              break
            } else {
              minNights = this.bookings.data[this.propertyid].minimum_nights
            }
          }
        } else {
          minNights = this.bookings.data[this.propertyid].minimum_nights
        }
        let checkoutnextDate = moment(nextDate).add(minNights, 'days').format('YYYY-MM-DD')
        this.chckOutDate = checkoutnextDate
        this.checkoutdate1 = checkoutnextDate
      } else { this.dateChanged = true }
    },
    // watch the checkout date, if changed, reload prices
    chckOutDate () {
      if (this.checkoutDateChanged) {
        this.checkAvailabilty()
      } else {
        this.checkoutDateChanged = true
      }
    }
  },
  computed: {
    pageCount () {
      let l = this.allProperties.length
      let s = this.size
      return Math.ceil(l / s)
    },
    allProperties () {
      let generatedProperties = []
      var innerProperties = Object.values(this.multiproperties)

      innerProperties.forEach((array) => {
        generatedProperties.push(array)
        // array.forEach(it => {
        //   generatedOffers.push(it)
        // })
      })
      return generatedProperties
    },
    paginatedData () {
      return this.allProperties.slice(
        (this.currentPage - 1) * this.size,
        this.currentPage * this.size
      )
    },
    totalPages () {
      return Math.ceil(this.allProperties.length / this.size)
    },
    // computed property for special offers
    sopageCount () {
      let l = this.allOffers.length
      let s = this.sosize
      return Math.ceil(l / s)
    },
    allOffers () {
      let generatedOffers = []
      var innerOffers = Object.values(this.offers)

      innerOffers.forEach((array) => {
        array.forEach((it) => {
          generatedOffers.push(it)
        })
      })
      return generatedOffers
    },
    sopaginatedData () {
      return this.allOffers.slice(
        (this.socurrentPage - 1) * this.sosize,
        this.socurrentPage * this.sosize
      )
    },
    sototalPages () {
      return Math.ceil(this.allOffers.length / this.sosize)
    },
    ...mapState({
      checkinDate: state => state.checkinDate,
      checkoutDate: state => state.checkoutDate
    }),
    mobileCheckinLabel () {
      return this.checkinDate ? moment(this.checkinDate).format('ddd, D MMM') : 'Select date'
    },
    mobileCheckoutLabel () {
      return this.checkoutDate ? moment(this.checkoutDate).format('ddd, D MMM') : 'Select date'
    }
  },
  methods: {
    disabledRange (date) {
      const mindate = moment(this.checkoutdate1).subtract(1, 'day').format('YYYY-MM-DD')
      return date < new Date(mindate)
    },
    disableDateBeforeToday (date) {
      const todaysDate = moment().subtract(1, 'day').format('YYYY-MM-DD')
      return date < new Date(todaysDate)
    },
    getCurrentImage (image, index, roomid) {
      this.currentImages[roomid] = {
        id: index,
        image: image[index]
      }
      return this.currentImages[roomid].image
    },
    getNextImage (index) {
      this.imageindex = index
    },
    redirectToListBooking (pid) {
      this.$router.push({
        path: '/?pid=' + btoa(pid)
      })
    },
    activateReadMore (pid) {
      let lessText = document.getElementById('lesstext' + pid)
      lessText.style.display = 'none'
      let moreText = document.getElementById('moretext' + pid)
      moreText.style.display = 'block'
    },
    activateReadLess (pid) {
      let lessText = document.getElementById('lesstext' + pid)
      lessText.style.display = 'block'
      let moreText = document.getElementById('moretext' + pid)
      moreText.style.display = 'none'
    },
    nextPage () {
      if (this.currentPage === this.pageCount) {
        this.currentPage = 1
      } else {
        this.currentPage++
      }
    },
    prevPage () {
      if (this.currentPage === 1) {
        this.currentPage = this.pageCount
      } else {
        this.currentPage--
      }
    },
    updateRoomFilter (propertyArr) {
      if (this.destination !== '') {
        var arrayFiltered = propertyArr.find(
          (x) => x.id === this.destination.toString()
        )
        this.filteredRoomTypeArray = arrayFiltered
      }
    },
    // method to get url parameters
    getDateData () {
      var minimumCheckinNights =
                    this.bookings.data[this.propertyid].minimum_checkin_nights
      var minimumNights = this.bookings.data[this.propertyid].minimum_nights
      if (minimumCheckinNights === 0) {
        var today = moment().format('YYYY-MM-DD')
        if (minimumNights === 0) {
          var tommorow = moment().add(1, 'days').format('YYYY-MM-DD')
        } else {
          tommorow = moment().add(minimumNights, 'days').format('YYYY-MM-DD')
        }
        this.checkoutdate1 = tommorow
        this.checkdate = today
        this.checkinDate = today
        this.chckInDate = today
        this.chckOutDate = tommorow
        this.checkoutDate = tommorow
      }
      if (minimumCheckinNights > 0) {
        let checkoutRange = minimumCheckinNights + minimumNights
        let futureDate1 = moment()
          .add(minimumCheckinNights, 'days')
          .format('YYYY-MM-DD')
        let nextdate1 = moment()
          .add(checkoutRange, 'days')
          .format('YYYY-MM-DD')
        this.checkoutdate1 = nextdate1
        this.checkdate = futureDate1
        this.chckIndate = futureDate1
        this.chckOutDate = nextdate1
        this.checkinDate = futureDate1
        this.checkoutDate = nextdate1
      }
      const payload2 = {
        checkin_date: this.checkinDate,
        checkout_date: this.checkoutDate
      }
      this.$store.commit('updateDates', payload2)
      this.period = this.calculateStayNights(this.checkinDate, this.checkoutDate)
      this.periodText = this.getPeriodText(this.period)
    },
    updateChildAges (event, index) {
      this.ageError = false
      index = parseInt(index) - 1
      this.childAges.splice(index, 0, event.target.value)
    },
    stickMenu () {
      var dropdowns = document.getElementsByClassName('dropdown-menu')
      var i
      for (i = 0; i < dropdowns.length; i++) {
        var openDropdown = dropdowns[i]
        if (openDropdown.classList.contains('hidden')) {
          openDropdown.classList.remove('hidden')
        }
      }
      document
        .getElementById('vue-dropdown-home')
        .addEventListener('click', function (event) {
          event.stopPropagation()
        })
      // Closes the menu in the event of outside click
      window.onclick = function (event) {
        if (!event.target.matches('.vue-small_large_select')) {
          var dropdowns = document.getElementsByClassName('dropdown-menu')
          var i
          for (i = 0; i < dropdowns.length; i++) {
            var openDropdown = dropdowns[i]
            if (openDropdown.classList.contains('show')) {
              openDropdown.classList.remove('show')
            }
          }
        }
      }
    },
    openProofModal (booking, board) {
      this.bookingDataProof = booking
      this.boardDataProof = board
    },
    changeRoomImage (bindex, total, direction) {
      const current = this.roomImageIndex[bindex] || 0
      const next = (current + direction + total) % total
      this.$set(this.roomImageIndex, bindex, next)
    },
    showPromoCode () {
      if (this.showpromo === false) {
        this.showpromo = true
      } else if (this.showpromo === true) {
        this.showpromo = false
      }
    },
    close () {
      var dropdowns = document.getElementsByClassName('dropdown-menu')
      var i
      for (i = 0; i < dropdowns.length; i++) {
        var openDropdown = dropdowns[i]
        if (openDropdown.classList.contains('show')) {
          openDropdown.classList.remove('show')
        } else {
          openDropdown.classList.add('hidden')
        }
      }
    },
    changeCheckoutDate (event) {
      var nextDate = event.target.value
      var stayrestrictions =
                this.bookings.data[this.propertyid].stay_restrictions
      if (stayrestrictions.length > 0) {
        for (const stayrestriction of stayrestrictions) {
          var startdate = moment(stayrestriction.start_date)
            .subtract(1, 'days')
            .format('YYYY-MM-DD')
          var enddate = moment(stayrestriction.end_date)
            .add(1, 'days')
            .format('YYYY-MM-DD')
          if (moment(this.chckInDate).isBetween(startdate, enddate) === true) {
            var minNights = stayrestriction.minimum_nights
            break
          } else {
            minNights = this.bookings.data[this.propertyid].minimum_nights
          }
        }
      } else {
        minNights = this.bookings.data[this.propertyid].minimum_nights
      }
      var checkoutnextDate = moment(nextDate)
        .add(minNights, 'days')
        .format('YYYY-MM-DD')
      this.chckOutDate = checkoutnextDate
      this.checkoutdate1 = checkoutnextDate
    },
    computeChildrenAgeRange (ageGroupsDetails) {
      var computedChildAges = []
      for (
        var i = parseInt(ageGroupsDetails.child_min_age); i <= parseInt(ageGroupsDetails.child_max_age); i++
      ) {
        computedChildAges.push({ age: i })
      }

      return computedChildAges
    },
    addAdult () {
      this.defaultAdultNo = parseInt(this.defaultAdultNo) + 1
      this.guest = this.guest + 1
    },
    removeAdult () {
      if (this.defaultAdultNo > 1) {
        this.defaultAdultNo = parseInt(this.defaultAdultNo) - 1
        this.guest = this.guest - 1
      }
    },
    addBabies () {
      this.defaultbabiesNo = parseInt(this.defaultbabiesNo) + 1
      this.guest = this.guest + 1
    },
    removeBabies () {
      if (this.defaultbabiesNo > 0) {
        this.defaultbabiesNo = parseInt(this.defaultbabiesNo) - 1
        this.guest = this.guest - 1
      }
    },
    addChildMobile () {
      this.defaultChildrenNo = parseInt(this.defaultChildrenNo)
      this.childrenCount = this.defaultChildrenNo
      this.children = this.childrenCount
      this.guest = this.guest + 1
    },
    addChildren () {
      if (this.childAges.length === parseInt(this.defaultChildrenNo)) {
        this.defaultChildrenNo = parseInt(this.defaultChildrenNo) + 1
        this.childrenCount = this.defaultChildrenNo
        this.children = this.childrenCount
        this.guest = this.guest + 1
      } else {
        this.ageError = true
      }
    },
    removeChildren () {
      if (this.defaultChildrenNo > 0) {
        this.ageError = false
        // remove child ages if
        this.defaultChildrenNo = parseInt(this.defaultChildrenNo) - 1
        this.childAges.splice(this.defaultChildrenNo, 1)
        this.guest = this.guest - 1
        this.childrenCount = this.defaultChildrenNo
        this.children = this.childrenCount
      }
    },
    addRoom () {
      ++this.room
    },
    removeRoom () {
      if (this.room !== 1) {
        --this.room
      }
    },
    cancPolicy (bookid) {
      if (this.canc === bookid) {
        this.canc = null
      } else {
        this.canc = bookid
      }
      this.descr = null
      this.term = null
    },
    termCondition (bookid) {
      if (this.term === bookid) {
        this.term = null
      } else {
        this.term = bookid
      }
      this.descr = null
      this.canc = null
    },
    rdetail (bookid) {
      if (this.descr === bookid) {
        this.descr = null
      } else {
        this.descr = bookid
      }
      this.term = null
      this.canc = null
    },
    // redirectToBookDetail function has been moved
    nonResident () {
      this.proof = false
      var residentButton = document.getElementById('btnres')
      var nonresidentButton = document.getElementById('btnnonres')
      nonresidentButton.classList.add('active')
      residentButton.classList.remove('active')
      if (
        this.bookings.data[this.propertyid].currency.res !== '' &&
                this.bookings.data[this.propertyid].currency.nonres === ''
      ) {
        this.proofRes = 0
      } else if (
        this.bookings.data[this.propertyid].currency.res === '' &&
                this.bookings.data[this.propertyid].currency.nonres !== ''
      ) {
        this.proofRes = 1
      } else {
        this.proofRes = 1
      }
      this.resident = 'non-resident'
    },
    localResident () {
      this.proof = true
      this.resident = 'resident'
      if (
        this.bookings.data[this.propertyid].currency.res !== '' &&
                this.bookings.data[this.propertyid].currency.nonres === ''
      ) {
        this.proofRes = 0
      } else if (
        this.bookings.data[this.propertyid].currency.res === '' &&
                this.bookings.data[this.propertyid].currency.nonres !== ''
      ) {
        this.proofRes = 1
      } else {
        this.proofRes = 0
      }
      var residentButton = document.getElementById('btnres')
      var nonresidentButton = document.getElementById('btnnonres')
      nonresidentButton.classList.remove('active')
      residentButton.classList.add('active')
    },
    async checkAvailabilty (type) {
      this.clicked = true
      this.babies = this.defaultbabiesNo
      this.children = this.defaultChildrenNo
      this.adult = this.defaultAdultNo
      var roomNo = 0
      if (this.adult >= 3 || this.guest >= 4) {
        roomNo = 2
      } else {
        roomNo = this.room
      }
      if (
        parseInt(this.room) === 1 &&
                parseInt(this.adult) === 0 &&
                parseInt(this.children) === 0
      ) {
        this.room = 1
        this.adult = 1
        this.children = 0
      } else {
        this.adult = parseInt(this.adult)
        this.children = parseInt(this.children)
      }
      this.guest =
                parseInt(this.adult) + parseInt(this.babies) + parseInt(this.children)
      const payload = {
        roomNo: roomNo,
        promoCode: this.promo,
        proofRes: this.proofRes,
        residency: this.resident
      }
      this.$store.commit('updateRoomNo', payload)
      // test id if no root id is found
      if (this.destination !== '') {
        this.propertyid = this.destination
        const configUrl = process.env.CONFIG_URL['live_url']
        const key = process.env.PMS_KEY['key']
        const config = {
          headers: { 'Accept': 'application/json' }
        }
        const payload = {
          'property_id': this.propertyid,
          'api': this.type
        }
        const configRes = await this.$http.post(configUrl, payload, config)
        if (configRes.status === 200) {
          let configData = this.CryptoJSAesDecrypt(key, configRes.data.property_details)
          configData = JSON.parse(configData)
          const passkey = configData[0].val_ptoken
          let consumerKey = configData[0].val_reserveport_secret_key
          const details = JSON.parse(configData[0].add_details)
          let fetchUrl = details.url
          const payload2 = {
            checkin_date: this.checkinDate,
            checkout_date: this.checkoutDate
          }
          this.$store.commit('updateDates', payload2)
          if (this.roomType !== '') {
            if (type === 's' || type === 'sa') {
              document.getElementById('btn_close').click()
            }
            this.$router.push({
              path: '/room-details?rid=' +
                                this.roomType +
                                '&pid=' +
                                btoa(this.propertyid)
            })
          }
          var childAgeRange = this.childAges.filter(Boolean)
          const postData = {
            checkin_date: this.checkinDate,
            checkout_date: this.checkoutDate,
            client_email: this.email,
            room: this.room,
            babies: this.babies,
            children: this.children,
            children_ages: childAgeRange,
            adults: this.adult,
            residency: this.resident,
            coupon_code: this.promo,
            isNonRefundable: this.nonRefundable
          }
          var postDataJson = JSON.stringify(postData)
          var encryptedData = this.CryptoJSAesEncrypt(passkey, postDataJson)
          this.isSearching = true
          try {
            const url = `${fetchUrl}/index.php`
            const formData = new FormData()
            formData.append('pid', this.propertyid)
            formData.append('consumer_key', consumerKey)
            formData.append('data', encryptedData)
            formData.append('option', 'com_goreserva_psearch')
            formData.append('task', 'api.searchAvailability')
            const response = await this.axios.post(url, formData)
            if (response) {
              let data = this.CryptoJSAesDecrypt(passkey, response.data.er)
              this.errors = false
              this.errorMsg = []
              if (data !== '') {
                data = JSON.parse(data)

                // only close the modal on an explicit "Check Availability" tap ('s'),
                // not on an auto refresh from changing a date ('sa') - keeps the modal
                // open so the user can keep adjusting checkout/guests after a fresh price load
                if (type === 's') {
                  if (parseInt(this.children) !== this.childAges.length) {
                    this.ageError = true
                  } else {
                    document.getElementById('btn_close').click()
                  }
                }
                let maximumOccupancy = 0
                let maximumAdultOccupancy = 0
                this.period = this.calculateStayNights(this.checkinDate, this.checkoutDate)
                this.periodText = this.getPeriodText(this.period)
                
                const maxNight = data.data[this.propertyid].maximum_nights
                for (const room of Object.values(data.data[this.propertyid].rooms)) {
                  if (parseInt(room.occupancy.maximumTotalOccupancy) > maximumOccupancy) {
                    maximumOccupancy = room.occupancy.maximumTotalOccupancy
                  }
                  if (parseInt(room.occupancy.maximumAdultOccupancy) > maximumAdultOccupancy) {
                    maximumAdultOccupancy = room.occupancy.maximumAdultOccupancy
                  }
                }
                if (parseInt(this.period) < parseInt(maxNight) && (this.room >= 2 || parseInt(this.guest) > maximumOccupancy || parseInt(this.adult) > parseInt(maximumAdultOccupancy))) {
                  if (this.$route.path === '/multi-property' || this.$route.path === '/') {
                    this.$router.push({
                      path: '/multi-room-selection/?pid=' + btoa(this.propertyid)
                    })
                  }
                }
                if (parseInt(this.period) > parseInt(maxNight)) {
                  this.clicked = true
                  this.dataToggle = 'tooltip'
                  this.errMsg = 'Maximum (' + maxNight + ') nights exceeded'
                  this.$toast.error(this.errMsg)
                } else {
                  this.clicked = false
                }
                this.bookings = data
                this.roomData = this.bookings.data[this.propertyid].rooms
                this.bookingData = this.bookings.data[this.propertyid]
                this.roomLabel = this.bookings.data[this.propertyid].room_label
                this.guestFormSettings =
                                        this.bookings.data[this.propertyid].guest_form_settings
                this.ageGroupsDetails =
                                        this.bookings.data[this.propertyid].age_group_details
                if (this.bookings.data[this.propertyid].rooms.length === 0) {
                  this.errors = true
                  this.errorMsg.push('No available rates')
                }
                for (const object of Object.values(
                  this.bookings.data[this.propertyid].rooms
                )) {
                  for (const board of Object.values(object.boards)) {
                    if (
                      board.roomPrice.res === 0 ||
                                                board.roomPrice.res === ''
                    ) {
                      this.residenceTab = true
                    }
                    if (
                      board.roomPrice.nonres === 0 ||
                                                board.roomPrice.nonres === ''
                    ) {
                      this.residenceTab = true
                    }
                  }
                }
                if (
                  this.bookings.data[this.propertyid].currency.res !== '' &&
                                        this.bookings.data[this.propertyid].currency.nonres === ''
                ) {
                  this.proofRes = 0
                  this.residenceTab = true
                } else if (
                  this.bookings.data[this.propertyid].currency.res === '' &&
                                        this.bookings.data[this.propertyid].currency.nonres !== ''
                ) {
                  this.proofRes = 1
                  this.residenceTab = true
                } else {
                  // gettting the default residency of the guest
                  if (
                    this.bookings.data[this.propertyid].guest_form_settings
                      .default_residency === 'res'
                  ) {
                    this.resident = 'resident'
                    this.proofRes = 0
                  } else if (
                    this.bookings.data[this.propertyid].guest_form_settings
                      .default_residency === 'nonres'
                  ) {
                    this.resident = 'non-resident'
                    this.proofRes = 1
                  }
                }

                const payload = {
                  bookingData: data,
                  stay_period: this.period,
                  babies: this.babies,
                  childAges: this.childAges
                }
                this.$store.dispatch('getBookingData', payload)
                this.isSearching = false
                this.loadResult = true
                this.getOffers(this.propertyid)
              } else {
                this.errors = true
                this.errorMsg.push('Failed to decrypte data')
              }
            }
          } catch (error) {}
          this.isSearching = false
        } else {
          this.propertyerror = true
        }
      } else {
        this.$alert('Please Choose Destination.', '', 'warning')
      }
    },
    // functions for special offers
    sonextPage () {
      if (this.socurrentPage === this.sopageCount) {
        this.socurrentPage = 1
      } else {
        this.socurrentPage++
      }
    },
    soprevPage () {
      if (this.socurrentPage === 1) {
        this.socurrentPage = this.sopageCount
      } else {
        this.socurrentPage--
      }
    },
    getCheckinDate (date) {
      let today = moment(date).format('YYYY-MM-DD')
      if (today === 'Invalid date') {
        today = moment().format('YYYY-MM-DD')
      } else {
        if (moment(date).isBefore(today) === true) {
          today = moment().format('YYYY-MM-DD')
        }
      }
      return today
    },
    getCheckoutDate (date, minnights) {
      let today = moment(date).format('YYYY-MM-DD')
      if (today === 'Invalid date') {
        today = moment().format('YYYY-MM-DD')
      } else {
        if (moment(date).isBefore(today) === true) {
          today = moment().format('YYYY-MM-DD')
        }
      }
      var tommorow = moment(today).add(minnights, 'days').format('YYYY-MM-DD')
      return tommorow
    },
    submitOffer () {
      document.getElementById('vueofferForm').submit()
    }
    // end function
  },
  mixins: [reusableData]
}
</script>

<style>
@import '../assets/styles/main.css';
</style>



// WEBPACK FOOTER //
// src/components/multiproperty.vue